module.exports = __webpack_public_path__ + "static/media/burgundy.6746a00a.png";